import React, { FC, PropsWithChildren } from 'react'
import cx from 'classnames'
import { Helmet, HelmetProps } from 'react-helmet-async'

import * as SC from './styled'

export type DefaultLayoutProps = PropsWithChildren<{
  className?: string
  helmet?: HelmetProps
  header?: React.ReactChild
  footer?: React.ReactChild
}>

const DefaultLayout: FC<DefaultLayoutProps> = ({
  children,
  className,
  helmet,
  header = null,
  footer = null,
}) => {
  return (
    <SC.Container className={cx(className)}>
      <Helmet {...helmet} />
      {header}
      {children}
      {footer}
    </SC.Container>
  )
}

export default DefaultLayout
